import React, { useMemo } from "react";
import { NearbySearch } from "../NearbySearch";
import { Box, Flex } from "@components/common/atoms";
import { NearbyViewProvider, useStoreAppValue } from "@hooks";
import styled from "@emotion/styled";
import { NearbyMap } from "../NearbyMap";
import { useLoadScript } from "@react-google-maps/api";
import { constants } from "@services";
// == Types ================================================================

interface IProps {}

// == Constants ============================================================

NearbyView.defaultProps = {};

// == Component ============================================================

const googleMapsLibraries = ["places"];

export default function NearbyView({ location }: IProps) {
  const { mapLocation, currency } = useStoreAppValue();
  const initialState = {
    coordinates: mapLocation
      ? {
          latitude: mapLocation.latitude,
          longitude: mapLocation.longitude,
          address: mapLocation.city,
        }
      : currency === "USD"
      ? constants.SAN_FRANCISCO_LAT_LNG
      : constants.TORONTO_LAT_LNG,
    query: "",
    distance: constants.DISTANCES_ENUM.DEFAULT_DISTANCE,
    // brandId: $brandId,
    linkTypes: [],
    linkTypeFilter: null, // has to be null
    results: [],
    loaded: false,
    brandId: null,
    location: location,
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyCb09gaz7FbmzLSflXiyTJLxpoapw_3g_I",
    libraries: googleMapsLibraries,
    mapTypeControl: false,
  });

  const urlLocation = useMemo(() => {
    return location;
  }, [location]);

  if (!isLoaded) return null;
  return (
    <NearbyViewProvider initialState={initialState}>
      <Flex>
        <ESearchBox>
          <NearbySearch location={urlLocation}></NearbySearch>
        </ESearchBox>
        <EMapBox>
          <NearbyMap />
        </EMapBox>
      </Flex>
    </NearbyViewProvider>
  );
}

// == Styles ===============================================================

const ESearchBox = styled(Box)`
  height: calc(100vh - (70px + 54.11px));
  width: 100%;
  @media only screen and (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    height: calc(100vh - 112px);
    width: 550px;
    border-right: ${({ theme }) => theme.borders.silver};
  }
`;

const EMapBox = styled(Box)`
  height: calc(100vh - (70px + 54.11px));
  width: 100%;
  display: none;
  @media only screen and (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    height: calc(100vh - 112px);
    display: block;
    width: calc(100% - 550px);
  }
`;
